import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
export const url = ({ resourceType, resourceId, relation, subjectType, }) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/identity/permission/resource/${resourceType}/id/${resourceId}/relation/${relation}/subject/${subjectType}`
    : `https://middleware.uat.farther.com/identity/permission/resource/${resourceType}/id/${resourceId}/relation/${relation}/subject/${subjectType}`;
const Response = z.object({
    data: z.object({
        exists: z.object({ subjectId: z.string() }).array(),
    }),
});
export const listSubjectsWithRelation = async (params, config) => {
    const { data } = await axios.get(url({
        resourceType: params.resourceType,
        resourceId: params.resourceId,
        relation: params.relation,
        subjectType: params.subjectType,
    }), {
        headers: {
            version: "20241023",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }), // For AdvisorRequestConfig
            ...("clientId" in config && { Client: config.clientId }), // For RequestConfig
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data.data.exists;
    }
    else {
        const errorMessage = `[getAccessToResource.ts] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getListSubjectsWithRelation.js.map